import type { Key9Result } from '../types/puzzle';
import type { DayProgress } from '../storage/localSave';
import { resultLabel } from './key9Validator';

export function buildShareText(date: string, result: Key9Result, streak?: number): string {
  if (result.status === 'missed') {
    return `DaySudoku #${date}\nKey9 · Missed\nMisses ${result.misses}/9\nStill solved as practice\n\ndaysudoku.com`;
  }

  const label = resultLabel(result.status);
  const time = formatTime(result.seconds);
  const streakLine = streak && streak > 1 ? `\n${streak}-day streak` : '';
  return `DaySudoku #${date}\nKey9 · ${label}\nPlaced 1–9 · Misses ${result.misses}/9 · Hints ${result.hints}\n${time}${streakLine}\n\ndaysudoku.com`;
}

export function buildFullShareText(date: string, progress: DayProgress, streak?: number): string {
  const time = formatTime(progress.fullSeconds ?? 0);
  const streakLine = streak && streak > 1 ? `\n${streak}-day streak` : '';
  const key9Line = progress.key9Result
    ? `Key9 · ${resultLabel(progress.key9Result.status)} · Misses ${progress.key9Result.misses}/9`
    : 'Key9 Unlocked';

  return `DaySudoku #${date}\nDone\n${key9Line}\nFull Sudoku · ${time}${streakLine}\n\ndaysudoku.com`;
}

export function formatTime(totalSeconds: number): string {
  const m = Math.floor(totalSeconds / 60).toString().padStart(2, '0');
  const s = Math.floor(totalSeconds % 60).toString().padStart(2, '0');
  return `${m}:${s}`;
}
